import { FieldError } from 'react-hook-form'
import styles from './ErrorMessage.module.scss'

type Props = {
  error?: FieldError
}

const ErrorMessage = ({ error }: Props) => <>{error && <span className={styles['error-message']}>{error.message}</span>}</>

export default ErrorMessage
